module.exports = __webpack_public_path__ + "static/eksisozluk-371d1f1ad3b97ed8f9bf4956c2ea267e.png";